import { useCategoryPageRequestId } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageRequestId";
import { useIsCategoryPageLoadedAndHasNoResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageLoadedAndHasNoResults";
import { useCategoryPageHeaderAndSubheaderTexts } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/HeaderAndSubheader/useCategoryPageHeaderAndSubheaderTexts";
import { BrandFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/BrandFirst/CategoryPageBrandFirstResults";
import { CategoryPageNoResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/NoResults/CategoryPageNoResults";
import { ProductFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/ProductFirst/CategoryPageProductFirstResults";
import { useIsProductOrBrandGridLoading } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/useIsProductOrBrandGridLoading";
import { useIsFullWidthCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsFullWidthCategory";
import { useShowProductFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/useShowProductFirstResults/useShowProductFirstResults";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import React from "react";

/** Renders a list of products or brands based on the category page view state */
export const CategoryPageProductOrBrandGrid = ({
  categoryPageLoadTimingRef,
  isScrollingToTop,
  onFirstBatchVisible,
}: {
  categoryPageLoadTimingRef?: React.Ref<HTMLDivElement>;
  isScrollingToTop?: boolean;
  onFirstBatchVisible?: () => void;
}) => {
  const { headerText } = useCategoryPageHeaderAndSubheaderTexts();
  const isLoading = useIsProductOrBrandGridLoading();

  const categoryModel = useCurrentCategoryModel();
  const requestId = useCategoryPageRequestId();
  const showEmptyList = useIsCategoryPageLoadedAndHasNoResults();
  const showProductFirstResults = useShowProductFirstResults();
  const isFullWidthCategory = useIsFullWidthCategory();

  if (showEmptyList) {
    return (
      <CategoryPageNoResults
        showProductFirstResults={showProductFirstResults}
        categoryPageLoadTimingRef={categoryPageLoadTimingRef}
      />
    );
  }

  if (showProductFirstResults) {
    return (
      <ProductFirstResults
        isLoading={isLoading}
        requestId={requestId}
        headerText={headerText}
        categoryModel={categoryModel}
        categoryPageLoadTimingRef={categoryPageLoadTimingRef}
        isScrollingToTop={isScrollingToTop}
        onFirstBatchVisible={onFirstBatchVisible}
        shouldRenderExtraTileOnXLScreen={isFullWidthCategory}
      />
    );
  }

  return (
    <BrandFirstResults
      isLoading={isLoading}
      requestId={requestId}
      headerText={headerText}
      categoryModel={categoryModel}
      categoryPageLoadTimingRef={categoryPageLoadTimingRef}
      isScrollingToTop={isScrollingToTop}
      onFirstBatchVisible={onFirstBatchVisible}
      shouldRenderExtraTileOnXLScreen={isFullWidthCategory}
    />
  );
};
